var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialmedia5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.506 0.0366661C9.06806 0.561171 4.21101 3.85362 1.74974 8.68379C0.879299 10.3921 0.364989 12.0393 0.0835682 14.0199C-0.0411738 14.8983 -0.0230762 17.1706 0.11657 18.1499C0.364551 19.889 0.877671 21.5369 1.66407 23.12C3.22429 26.2607 5.71675 28.751 8.86617 30.3159C13.9716 32.8527 20.0054 32.5039 24.7674 29.3966C26.6293 28.1817 28.3939 26.3805 29.5986 24.4654C30.0564 23.7374 30.7477 22.3223 31.0617 21.4704C31.378 20.6119 31.7469 19.1219 31.8838 18.1499C32.0224 17.1653 32.0411 14.8874 31.9177 14.0199C31.548 11.4214 30.7234 9.20911 29.3543 7.14301C28.772 6.26433 28.1905 5.55541 27.3804 4.73662C24.8828 2.21234 21.776 0.646773 18.2234 0.122331C17.4574 0.00925824 15.3045 -0.0403638 14.506 0.0366661ZM18.0982 10.2017C19.5566 10.2434 21.3247 10.3985 21.7589 10.5228C22.5127 10.7386 23.2302 11.2735 23.5059 11.8251C23.7726 12.3588 24.0165 14.3477 24.0153 15.9788C24.0141 17.5412 23.7603 19.6405 23.5143 20.1223C23.2194 20.7 22.551 21.2205 21.8268 21.4364C20.1474 21.9373 11.8534 21.9373 10.174 21.4364C9.44974 21.2205 8.78138 20.7 8.48643 20.1223C8.24096 19.6415 7.98615 17.5372 7.98615 15.9911C7.98615 14.2948 8.24315 12.3127 8.53177 11.7827C8.84738 11.2033 9.63153 10.6556 10.3882 10.4861C11.156 10.3142 14.954 10.1026 16.4074 10.1508C16.7174 10.1611 17.4783 10.184 18.0982 10.2017ZM14.0591 15.9911V19.0676L14.3608 18.8904C15.2759 18.3526 19.0634 16.0176 19.0634 15.9911C19.0634 15.9645 15.2759 13.6295 14.3608 13.0918L14.0591 12.9146V15.9911Z",
    fill: "#EEEEEE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmedia5);
export default __webpack_public_path__ + "static/media/socialmedia5.3a4fba7040e34abdd62b6c5078666402.svg";
export { ForwardRef as ReactComponent };